export default __webpack_public_path__ + "static/dropbox-be6f425a7230980fb9b9323f6358c1f5.png";